module.exports = __webpack_public_path__ + "static/media/bq.d6da2e84.svg";